module.exports = __webpack_public_path__ + "static/media/oxygen-sensor-heater-monitor.2048527f.svg";